module.exports = __webpack_public_path__ + "assets/img/stihl-all-inclusive-price.5e106f9c.png";